<nz-select
  [ngModel]="value"
  [nzDisabled]="disabled"
  [nzPlaceHolder]="'LOT_BIDDING_MODAL.SELECT_CONDITIONS' | translate"
  (ngModelChange)="handleConditionChange($event)"
  (nzBlur)="markAsTouched()"
>
  <nz-option
    *ngFor="let condition of bidConditions"
    [nzValue]="+condition.id"
    [nzLabel]="condition.title | translate"
  ></nz-option>
</nz-select>

<nz-alert
  *ngIf="isDisassemblySelected && isRussianClient"
  [nzType]="'warning'"
  [nzMessage]="'LOT_BIDDING_MODAL.VAT_ALERT' | translate"
></nz-alert>
